<template lang="pug">
  .deal-room
    vue-headful(
      :title="title"
    )
    img(src="../assets/vrify_header.png")
    el-row(:gutter=25 type="flex")
      el-col(:span="24")
        el-row(type="flex" justify="center")
          .deal-room-menu
            .deal-room-header
              h1 Deal Room
              .deal-room-number
                h3 {{ numberFound }} found
            .deal-room-filters
              el-menu(
                mode="horizontal"
                :default-active="activeIndex"
                )
                el-submenu(index="Region")
                  template(slot="title") REGION
                  el-menu-item(v-for="region in regions" v-bind:key="region" :index="region" @click="handleClick") {{ region }}
                el-submenu(index="Stage")
                  template(slot="title") STAGE
                  el-menu-item(v-for="stage in stages" v-bind:key="stage" :index="stage" @click="handleClick") {{ stage }}
                el-submenu(index="Commodity")
                  template(slot="title") COMMODITY
                  el-menu-item(v-for="commodity in commodities", v-bind:key="commodity" :index="commodity" @click="handleClick") {{ commodity }}
                el-submenu(index="Market Cap")
                  template(slot="title") MARKET CAP
                el-submenu(index="Listing")
                  template(slot="title") LISTING
                  el-menu-item(v-for="listing in listings" v-bind:key="listing" :index="listing" @click="handleClick") {{ listing }}
                el-submenu(index="Content")
                  template(slot="title") CONTENT
                  el-menu-item(v-for="content in contents" v-bind:key="content" :index="content" @click="handleClick") {{ content }}
                el-submenu(index="Sort")
                  template(slot="title") SORT BY
                  el-menu-item(index="Market Cap" @click="handleSortClick") Market Cap
        el-row(type="flex" :class="filters.length > 0 ? 'deal-room-active-filters' : 'deal-room-no-active-filters'")
          .deal-room-active-filter-list
            el-tag(
              v-for="filter in sortedFilters"
              v-bind:key="filter"
              closable
              @close="handleClose(filter)"
              ) {{ filter.name }}
        el-row(type="flex" justify="center")
          .deal-room-output
            el-col(:span="15")
              .deal-room-list
                company-card(v-for="company in filteredData" v-bind:key="company.name" :company="company")
                p(v-if="numberFound === 0") No companies found
            el-col(:span="9")
              .deal-room-chart
                img(src="https://via.placeholder.com/522x698.png")

</template>

<script>

import CompanyData from '../assets/dealroom.json'
import CompanyCard from '../components/companyCard'

export default {
  name: 'deal-room',
  components: { CompanyCard },
  data: function () {
    return {
      title: 'Deal Room',
      activeIndex: '1',
      companyData: [],
      filters: [],
      sortBy: null,
      regions: ['North America', 'South America', 'Africa', 'Europe', 'Australia', 'Asia'],
      commodities: ['Gold', 'Silver', 'Copper', 'Zinc', 'Lead', 'Nickel'],
      listings: ['XTSE', 'XTSXV', 'LSE'],
      contents: ['Vrified', 'Heart'],
      stages: ['Production', 'Development', 'Feasibility', 'Pre-Feasibility', 'PEA', 'Resource', 'Exploration']
    }
  },
  mounted () {
    this.companyData = CompanyData
  },
  computed: {
    filteredData () {
      let filteredData = this.companyData.filter(company => { return this.filter(company) })

      if (this.sortBy === 'Market Cap') {
        filteredData = filteredData.reverse(function (a, b) {
          return a.marketCap - b.marketCap
        })
      }

      return filteredData
    },
    sortedFilters () {
      return this.filters
    },
    numberFound () {
      return this.filteredData.length
    }
  },
  methods: {
    handleClose (filter) {
      this.removeFilter(filter)
    },
    handleClick (item) {
      let newFilter = { name: item.index, type: item.$parent.index }
      this.addFilter(newFilter)
    },
    handleSortClick (item) {
      this.sortBy = item.index
    },
    addFilter (filter) {
      if (!this.filterExists(filter)) {
        this.filters.push(filter)
      } else {
        this.removeFilter(filter)
      }
    },
    removeFilter (filter) {
      this.filters.splice(this.filters.indexOf(filter), 1)
    },
    filterExists (filter) {
      for (let existingFilter of this.filters) {
        if (existingFilter.name === filter.name && existingFilter.type === filter.type) {
          return true
        }
      }
      return false
    },
    filter (company) {
      if (!this.passFilter('Region', company.region)) { return false }
      if (!this.passFilter('Stage', company.stage)) { return false }
      if (!this.passFilter('Listing', company.listing.exchange)) { return false }
      if (!this.passCommodityFilter(company.commodities)) { return false }
      if (!this.passContentFilter(company)) { return false }
      return true
    },
    filterFilters (filterType) {
      return this.filters.filter(filter => { return filter.type === filterType }).map(filter => { return filter.name })
    },
    filterTypeExists (filterType) {
      let filterList = this.filterFilters(filterType)
      return filterList.length > 0
    },
    passFilter (filterType, value) {
      if (!this.filterTypeExists(filterType)) { return true }
      let filterList = this.filterFilters(filterType)
      if (filterList.includes(value)) { return true } else { return false }
    },
    passCommodityFilter (commodities) {
      if (!this.filterTypeExists('Commodity')) { return true }
      let filterList = this.filterFilters('Commodity')
      for (let commodityFilter of filterList) {
        if (commodities.includes(commodityFilter)) {
          return true
        }
      }
      return false
    },
    passContentFilter (company) {
      if (!this.filterTypeExists('Content')) { return true }
      let filterList = this.filterFilters('Content')
      for (let contentFilter of filterList) {
        if (contentFilter === 'Heart') {
          return company.heart
        } else if (contentFilter === 'Vrified') {
          return company.vrified
        }
      }
      return false
    }
  }
}

</script>

<style scoped>
.deal-room {
  width: 100%;
}

.deal-room h1 {
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 48px;
  font-family: Gilroy;
  color: #00000;
  font-weight: bold;
  letter-spacing: 0.56px;
}

.deal-room h2 {
  color: #333;
  font-weight: 600;
  font-size: 27px;
  margin-top: 2px;
  margin-bottom: 23px;
}

.deal-room h3 {
  color: #9E9E9E;
  font-family: Gilroy;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.23px;
}

.deal-room .deal-room-header {
  display: flex;
  position: relative;
  padding-top: 30px;
  padding-bottom: 15px;
}

.deal-room .deal-room-header h3 {
  color: #9E9E9E;
  position: absolute;
  bottom: 3px;
}

.deal-room .deal-room-header .deal-room-number {
  padding-left: 10px;
  margin-bottom: 22px;
}

.deal-room .deal-room-menu,
.deal-room .deal-room-output {
  width: 100%;
  margin-left: 28px;
  margin-right: 28px;
}

.deal-room .deal-room-output {
  padding-top: 13px;
}

.deal-room .deal-room-list {
  margin-right: 38px;
}

.deal-room .el-menu-item {
  font-family: Gilroy;
  font-size: 14px;
  color: black;
  letter-spacing: 0.16px;
}

.deal-room .el-submenu__title {
  font-size: 14px !important;
  color: black !important;
}

.deal-room .el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 14px !important;
  color: black !important;
}

.deal-room .deal-room-no-active-filters {
  height: 45px;
  background-color: white;
}

.deal-room .deal-room-active-filters {
  height: 45px;
  background-color: #F2F2F2;
}

.deal-room .deal-room-active-filters .deal-room-active-filter-list {
  padding-left: 28px;
}

.deal-room .el-tag {
  background-color: white;
  margin-top: 5px;
  margin-left: 5px;
  border-color: #F2F2F2;
}
</style>
